import { SubAPI } from "./SubAPI";
export class Keying2 extends SubAPI {
    list(props) { return this.fetcher.get("/api/keying2", props); }
    update(input) { return this.fetcher.post("/api/keying2", input); }
    updateShortcodeDetailed(input) { return this.fetcher.post("/api/keying2/shortcode/detailed", input); }
    upsertShortcode(input) { return this.fetcher.post("/api/keying2/shortcode", input); }
    searchOpenings(input) { return this.fetcher.get("/api/keying2/openings/search", input); }
    upsertProducts(input) { return this.fetcher.post("/api/keying2/products", input); }
    upsertLink(input) { return this.fetcher.post("/api/keying2/link", input); }
    getPending(props) { return this.fetcher.get("/api/keying2/pending", props); }
    getDetailsForPO(props) { return this.fetcher.get("/api/keying2/for-po", props); }
    listLibraryEntries() { return this.fetcher.get("/api/keying2/label-library"); }
    upsertLibraryEntry(input) { return this.fetcher.post("/api/keying2/label-library", input); }
    applyLibrary(input) { return this.fetcher.post("/api/keying2/apply-library", input); }
    copyFromProject(input) { return this.fetcher.post("/api/keying2/copy-from-project", input); }
    setBaseBuilding(input) { return this.fetcher.post("/api/keying2/base-building", input); }
}
